<template>
  <message-page-with-image title="Timeout" :subtitle="message" imgAlt="Sad Kanye" :imgSrc='kanyeImg'/>
</template>

<script>
import { defineComponent } from 'vue'
import MessagePageWithImage from '../components/error/MessagePageWithImage'
import i18n from '../plugins/vue-i18n';
import kanyeImg from '../assets/kanye.png';

export default defineComponent({
  components:{
    MessagePageWithImage
  },
  setup(){
    const message = i18n.t('http_errors.timeout');

    return {
      message,
      kanyeImg
    }
  }
})
</script>